import React from 'react';
import { Avatar, Box, } from '@mui/material';

const avatars = [
    'https://randomuser.me/api/portraits/men/32.jpg',
    'https://randomuser.me/api/portraits/women/44.jpg',
    'https://randomuser.me/api/portraits/women/68.jpg',
];

const AvatarGroup = () => {
    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            {avatars.map((src, index) => (
                <Avatar
                    key={index}
                    src={src}
                    sx={{
                        width: '40px',
                        height: '40px',
                        border: '1px solid #FFFFFF',
                        marginRight: index === 0 ? -1.5 : -1.5,
                        zIndex: avatars.length - 0,
                    }}
                />
            ))}
            <Avatar
                sx={{
                    width: '38px',
                    height: '38px',
                    fontSize: '12px',
                    fontWeight: 600,
                    backgroundColor: '#000',
                    color: '#FFFFFF',
                    marginRight: 0,
                    zIndex: 4,
                }}
            >
                5+
            </Avatar>
        </Box>
    );
};

export default AvatarGroup;
